export enum MeasurementRounding {
  Default = 'default',
  OneQuarterInch = 'one-quarter-inch',
  OneHalfInch = 'one-half-inch',
  OneInch = 'one-inch',
  Meters = 'meters',
}
